import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Default = _resolveComponent("Default")!
  const _component_DragAndDrop = _resolveComponent("DragAndDrop")!
  const _component_TrueOrFalse = _resolveComponent("TrueOrFalse")!
  const _component_Gap = _resolveComponent("Gap")!

  return (_openBlock(), _createElementBlock("main", null, [
    (_ctx.questionType === _ctx.QuestionType.DEFAULT)
      ? (_openBlock(), _createBlock(_component_Default, { key: 0 }))
      : (_ctx.questionType === _ctx.QuestionType.DRAG_AND_DROP)
        ? (_openBlock(), _createBlock(_component_DragAndDrop, { key: 1 }))
        : (_ctx.questionType === _ctx.QuestionType.TRUE_OR_FALSE)
          ? (_openBlock(), _createBlock(_component_TrueOrFalse, { key: 2 }))
          : (_ctx.questionType === _ctx.QuestionType.FILL_IN_THE_BLANKS)
            ? (_openBlock(), _createBlock(_component_Gap, { key: 3 }))
            : _createCommentVNode("", true)
  ]))
}